/**
 * AI Assistant (Workflow Builder) — temporary gate + defaults.
 * Change `staticPassword` anytime. Replace this gate later with real auth.
 */
export const AI_ASSISTANT_GATE = {
  enabled: true,
  /** Temporary static password to open the AI Assistant panel. */
  staticPassword: '123456789',
  sessionKey: 'aiAssistantUnlocked',
} as const;

export const AI_ASSISTANT_DEFAULTS = {
  panelWidth: 420,
  minWidth: 340,
  maxWidth: 640,
  maxHistoryVersions: 30,
  providers: [
    { id: 'openai', label: 'OpenAI', models: ['gpt-4o', 'gpt-4o-mini', 'gpt-4.1', 'gpt-4.1-mini'] },
    { id: 'anthropic', label: 'Anthropic', models: ['claude-sonnet-4-5', 'claude-haiku-4-5', 'claude-opus-4'] },
    { id: 'google', label: 'Google', models: ['gemini-2.5-flash', 'gemini-2.5-pro', 'gemini-2.0-flash'] },
    { id: 'deepseek', label: 'DeepSeek', models: ['deepseek-chat', 'deepseek-reasoner'] },
  ],
  defaultProvider: 'google' as const,
  defaultModel: 'gemini-2.5-flash',
  tokenSource: 'system' as 'system' | 'external',
};

export type AiAssistantProviderId = (typeof AI_ASSISTANT_DEFAULTS.providers)[number]['id'];
export type AiAssistantMode = 'suggest' | 'edit';
